import SendIcon from "@mui/icons-material/Send";
import { Box, Chip, DialogContent, Link, Typography } from "@mui/material";
import { GridModalFormProps, PageHeader } from "common";
import I18n from "i18n";
import moment from "moment";
import { Link as RLink } from "react-router-dom";
import { BulkEmailSentItem } from "./bulkEmailSentApi";

function Row({ label, value }: { label: string; value?: React.ReactNode }) {
  return (
    <Box sx={{ display: "flex", gap: 2, py: 0.75 }}>
      <Typography variant="body2" color="text.secondary" sx={{ minWidth: 160 }}>
        {label}
      </Typography>
      <Typography variant="body2">{value ?? "—"}</Typography>
    </Box>
  );
}

export default function BulkEmailSentView({
  listItem,
  onClose,
}: GridModalFormProps) {
  const item = listItem as BulkEmailSentItem | undefined;

  return (
    <>
      <PageHeader
        avatar={<SendIcon />}
        title={`${I18n.t("BulkEmailSent.titleSingular")} #${item?.id}`}
        subtitle={item?.email}
        onClose={onClose}
      />
      <DialogContent>
        <Row
          label={I18n.t("BulkEmailSent.attributes.booking_number")}
          value={
            item?.booking_id ? (
              <Link component={RLink} to={`/bookings/${item.booking_id}`}>
                {item.booking_number}
              </Link>
            ) : (
              item?.booking_number
            )
          }
        />
        <Row
          label={I18n.t("BulkEmailSent.attributes.program_name")}
          value={item?.program_name}
        />
        <Row
          label={I18n.t("BulkEmailSent.attributes.start_time")}
          value={
            item?.start_time
              ? moment(item.start_time).format("L LT")
              : undefined
          }
        />
        <Row
          label={I18n.t("BulkEmailSent.attributes.booking_name")}
          value={item?.booking_name}
        />
        <Row
          label={I18n.t("BulkEmailSent.attributes.email")}
          value={item?.email}
        />
        <Row
          label={I18n.t("BulkEmailSent.attributes.template_name")}
          value={item?.template_name}
        />
        <Row
          label={I18n.t("BulkEmailSent.attributes.sent_at")}
          value={
            item?.sent_at ? moment(item.sent_at).format("L LT") : undefined
          }
        />
        <Row
          label={I18n.t("BulkEmailSent.attributes.queue_name")}
          value={item?.queue_name}
        />
        <Row
          label={I18n.t("BulkEmailSent.attributes.error_code")}
          value={
            item?.error_code === 0 ? (
              <Chip size="small" label="OK" color="success" />
            ) : (
              <Chip size="small" label={item?.error_code} color="error" />
            )
          }
        />
        {item?.error_message && (
          <Row
            label={I18n.t("BulkEmailSent.attributes.error_message")}
            value={item.error_message}
          />
        )}
      </DialogContent>
    </>
  );
}
